import { render } from "./sideBar.vue?vue&type=template&id=4fe47ba4"
import script from "./sideBar.vue?vue&type=script&lang=js"
export * from "./sideBar.vue?vue&type=script&lang=js"

import "./sideBar.vue?vue&type=style&index=0&id=4fe47ba4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__